export default {
  studentEnrollDetail: {
    id: '',
    studentEnroll: '',
    student: null,
    enrollNo: '',
    courseOutlineRegistration: null,
    classSection: null,
    sectionNo: null,
    subject: null,
    subjectCode: '',
    teacher: null,
    teacherCode: '',
    credit: null,
    learnSpanNo: null,
    examSpanNo: null,
    exams: [],
    isDrop: null,
  },
  studentEnrollDetails: [],
  processing: false,
  error: null,
  success: null,
}



